import { contextPath } from 'disy';

// The following import doesn't work, because
// this bundle is loaded before disyCommons:
// import { getUrl } from 'disyCommons';

/**
 * Prefix relative URLs with the context path
 *
 * See net.disy.cadenza.web.taglib.util.UrlEncodingUtilities
 */
export default (url) => {
  if (url) {
    if (/^[a-z]+:/i.test(url)) {
      return url;
    } else {
      return getUrl(contextPath + url);
    }
  }
  return '';
};

function getUrl (url) {
  return window.disyCommons.getUrl(url);
}
